export const TAG = {
  // Tag name for all posts
  ALL: 'All',
}

export const SITE_LINKS = {
  mainLink: 'https://ellismin.com',
}
